export const nationalities = [
  "Indonesian",
  "Malaysian",
  "Hong Kong",
  "Taiwanese",

  "Myanmarese",
  "Filipino",
  "Sri Lankan",
  "Indian",
  "Other"

];
//modifying the list need to modify functions : phone nnumber code and currency code in biodata
export const countries = [
  "Singapore",
  "Malaysia",
  "Hong Kong",
  "Taiwan",
  "Middle East",
  "Philippines",
  "Myanmar",
  "Sri Lanka",
  "Indonesia",
  "India",
  "Other"
];

export const employernationalities = [
  "Indonesian",
  "Malaysian",
  "Hong Kong",
  "Taiwanese",
  "Myanmarese",
  "Filipino",
  "Singaporean",
  "Sri Lankan",
  "Indian",
  "Other"

];

